/**
 * Свечение под курсором в блоке "Где купить".
 *
 * Раньше это был один размытый блок под всей сеткой логотипов: он был виден
 * сквозь прозрачные плитки, а всё лишнее закрывали белые тени вокруг них.
 * В неполном последнем ряду закрывать было нечем — свечение вылезало
 * в пустые ячейки по бокам списка.
 *
 * Теперь свечение — это фон-градиент внутри каждой плитки (.buying__glow).
 * Модуль задаёт всем плиткам одну и ту же точку центра (в координатах
 * .buying__col), поэтому визуально блик остаётся общим и непрерывным,
 * но нарисоваться вне плитки он не может в принципе: пустых ячеек
 * с элементом .buying__glow просто нет.
 *
 * NOTE: только то, что есть в Safari 12+ — radial-gradient,
 * background-position/-size, requestAnimationFrame.
 */
itsoftApp.createModule("buyingGlow", ["pageLoad", "windowResize"], function () {
    const module = this;

    const DESKTOP_MIN_WIDTH = 1024; // синхронизировано с брейкпоинтом desktop в стилях
    const SHOW_CLASS = "_show";

    const BuyingGlow = function (container) {
        this.container = container;
        this.glows = container.querySelectorAll(".js-buying-glow");
        this.offsets = [];      // смещения плиток относительно контейнера
        this.radius = 0;        // половина размера градиента (задан в CSS)
        this.measured = false;
        this.frame = null;
        this.pointerX = 0;
        this.pointerY = 0;

        if (this.glows.length) {
            this.init();
        }
    };


    BuyingGlow.prototype.isDesktop = function () {
        return itsoftApp.calculations.viewWidth >= DESKTOP_MIN_WIDTH;
    };


    /**
     * Замер геометрии: смещения плиток и размер градиента.
     * Делается один раз на каждый размер окна, а не на каждое движение мыши.
     */
    BuyingGlow.prototype.measure = function () {
        const THIS = this;
        const rect = THIS.container.getBoundingClientRect();
        let size, glowRect, i, len;

        THIS.offsets = [];

        for (i = 0, len = THIS.glows.length; i < len; i++) {
            glowRect = THIS.glows[i].getBoundingClientRect();
            THIS.offsets.push([glowRect.left - rect.left, glowRect.top - rect.top]);
        }

        // размер блика берём из CSS, чтобы не дублировать значение в JS
        // (Safari может вернуть его в виде "calc(600px)" — достаём число регуляркой)
        size = /(-?[\d.]+)px/.exec(getComputedStyle(THIS.glows[0]).backgroundSize);
        THIS.radius = size ? parseFloat(size[1]) / 2 : 0;
        THIS.measured = THIS.radius > 0;

        return THIS.measured;
    };


    /**
     * Ставит центр блика в точку курсора — одинаково для всех плиток.
     */
    BuyingGlow.prototype.render = function () {
        const THIS = this;
        let offset, i, len;

        THIS.frame = null;

        for (i = 0, len = THIS.glows.length; i < len; i++) {
            offset = THIS.offsets[i];
            THIS.glows[i].style.backgroundPosition =
                Math.round(THIS.pointerX - offset[0] - THIS.radius) + "px " +
                Math.round(THIS.pointerY - offset[1] - THIS.radius) + "px";
        }
    };


    BuyingGlow.prototype.setPointer = function (e) {
        const THIS = this;
        const rect = THIS.container.getBoundingClientRect();

        THIS.pointerX = e.clientX - rect.left;
        THIS.pointerY = e.clientY - rect.top;
    };


    BuyingGlow.prototype.onEnter = function (e) {
        const THIS = this;

        if (!THIS.isDesktop()) {
            return;
        }

        if (!THIS.measured && !THIS.measure()) {
            return;
        }

        THIS.setPointer(e);
        THIS.render();
        THIS.container.classList.add(SHOW_CLASS);
    };


    BuyingGlow.prototype.onMove = function (e) {
        const THIS = this;

        if (!THIS.measured || !THIS.isDesktop()) {
            return;
        }

        THIS.setPointer(e);

        if (THIS.frame === null) {
            THIS.frame = window.requestAnimationFrame(THIS.render.bind(THIS));
        }
    };


    BuyingGlow.prototype.onLeave = function () {
        const THIS = this;

        THIS.container.classList.remove(SHOW_CLASS);

        if (THIS.frame !== null) {
            window.cancelAnimationFrame(THIS.frame);
            THIS.frame = null;
        }
    };


    BuyingGlow.prototype.onResize = function () {
        const THIS = this;

        // геометрия поменялась — пересчитаем при следующем наведении
        THIS.measured = false;

        if (!THIS.isDesktop()) {
            THIS.onLeave();
        }
    };


    BuyingGlow.prototype.init = function () {
        const THIS = this;

        THIS.container.addEventListener("mouseenter", THIS.onEnter.bind(THIS));
        THIS.container.addEventListener("mousemove", THIS.onMove.bind(THIS));
        THIS.container.addEventListener("mouseleave", THIS.onLeave.bind(THIS));

        itsoftApp.modules.windowResize.addEvent(THIS.onResize.bind(THIS), "buyingGlow");
    };


    const containers = document.querySelectorAll(".js-buying-glow-container");
    let i, len;

    if (containers.length) {
        if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth) {
            itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth = true;
        }

        if (itsoftApp.calculations.viewWidth === null) {
            itsoftApp.utils.getViewportSize();
        }

        for (i = 0, len = containers.length; i < len; i++) {
            new BuyingGlow(containers[i]);
        }
    }

    module.callback = BuyingGlow;
});
